var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "layout-padding" }, [
      _c(
        "div",
        { staticClass: "row q-mb-lg bg-white round-borders" },
        [_c("active-time-entry")],
        1
      ),
      _vm.timeTrackingStatisticsLoaded
        ? _c("div", { staticClass: "row gutter-sm" }, [
            _c(
              "div",
              { staticClass: "col-md-6 col-12" },
              [_c("project-hours", { attrs: { data: _vm.projectHours } })],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-6 col-12" },
              [
                _c("billable-hours", {
                  style: { height: "calc(50% - 0.5rem)", marginBottom: "1rem" },
                  attrs: { amount: _vm.billableHours }
                }),
                _c("open-hours", {
                  style: { height: "calc(50% - 0.5rem)" },
                  attrs: { amount: _vm.unbilledHours }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "q-mt-lg" },
        [
          _c(
            "div",
            { staticClass: "row justify-between items-end q-mb-md" },
            [
              _c(
                "span",
                { staticClass: "q-title text-bold text-blue-grey-4" },
                [_vm._v(_vm._s(_vm.$t("recent_time_entries")))]
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link q-subheading text-blue-grey-4",
                  attrs: { to: { name: "time-entries" } }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("view_all")) + "\n        "
                  )
                ]
              )
            ],
            1
          ),
          _vm.timeEntries.length
            ? [
                _c("time-entries-list", {
                  attrs: { "time-entries": _vm.timeEntries, showUser: false }
                })
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "row justify-center items-center col-grow q-mt-xl"
                  },
                  [
                    _c("div", { staticClass: "text-center" }, [
                      _c("img", {
                        attrs: {
                          src: require("assets/emptystates/time_entries_empty.svg")
                        }
                      }),
                      _c("h6", { staticClass: "q-my-md text-faded" }, [
                        _vm._v(_vm._s(_vm.$t("no_time_entries")))
                      ])
                    ])
                  ]
                )
              ]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }